import { HATV_FLAGGED_KPIS } from '../../../constants/dataConstants';

export const HATV_DEFAULT_TAB = 'hatv_q_month_approval';

export const getInitialHatvTab = (searchParams: URLSearchParams) =>
  searchParams.get('tab') || localStorage.getItem('selectedHATVLink') || HATV_DEFAULT_TAB;

export const getSelectedBulkOption = (selectedBulkAction: string | null) => {
  if (selectedBulkAction === 'hatvdashboard_bulk_approval') {
    return 'hatvdashboard_approval';
  }
  if (selectedBulkAction === 'hatvdashboard_bulk_route') {
    return 'hatvdashboard_route';
  }
  return '';
};

export const flaggedKpis = [
  HATV_FLAGGED_KPIS.groupSize,
  HATV_FLAGGED_KPIS.contributorCount,
  HATV_FLAGGED_KPIS.highestPpvInGroup,
  HATV_FLAGGED_KPIS.volumeFluctuation,
  HATV_FLAGGED_KPIS.eomGpv,
  HATV_FLAGGED_KPIS.tenure,
];